import { ErrorResponse } from 'types/form';
import { ApiResources, FALLBACK_ERROR_MESSAGE, getRequestHeaders, getUrl, Methods, processResponse } from './utils';

interface IGetYearResponse {
  modelYear: string;
}

interface IGetMakeResponse {
  makeId: string;
  makeName: string;
}

interface IGetModelResponse {
  modelName: string;
}

export const getYear = async (): Promise<IGetYearResponse[] | ErrorResponse> => {
  const endpoint = `${getUrl(ApiResources.vehicleYears)}`;
  const request = {
    method: Methods.get,
    headers: await getRequestHeaders(),
  };
  try {
    const yearResponse = await fetch(endpoint, request);
    return processResponse(yearResponse);
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : FALLBACK_ERROR_MESSAGE);
  }
};

export const getMake = async (year: string): Promise<IGetMakeResponse[] | ErrorResponse> => {
  const endpoint = `${getUrl(ApiResources.vehicleMake)}?yearID=${year}`;
  const request = {
    method: Methods.get,
    headers: await getRequestHeaders(),
  };
  try {
    const makeResponse = await fetch(endpoint, request);
    return processResponse(makeResponse);
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : FALLBACK_ERROR_MESSAGE);
  }
};

export const getModel = async (year: string, make: string): Promise<IGetModelResponse[] | ErrorResponse> => {
  const endpoint = `${getUrl(ApiResources.vehicleModel)}?yearID=${year}&makeID=${make}`;
  const request = {
    method: Methods.get,
    headers: await getRequestHeaders(),
  };
  try {
    const modelResponse = await fetch(endpoint, request);
    return processResponse(modelResponse);
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : FALLBACK_ERROR_MESSAGE);
  }
};
